import type { ReactNode } from 'react';
import { TriangleAlert } from 'lucide-react';

/** A short caution beside what it is about. */
export const Note = ({ children }: { children: ReactNode }) => (
	<p role='status' className='flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-xs leading-4.5 text-amber-800'>
		<TriangleAlert className='mt-0.5 size-3.5 shrink-0' aria-hidden />
		<span>{children}</span>
	</p>
);
